import axios from "axios";

const instance = axios.create({
  baseURL: "/.netlify/functions/",
});

// Add a request interceptor
instance.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
instance.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  async function (error) {
    //  Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    if (error && error.response && error.response.status === 500) {
      return "Something went wrong. Please try again.";
    }

    return error && error.response && error.response.data ? error.response.data : Promise.reject(error);
  }
);

export default instance;
